import React from "react";
import logoMinisterio from "../assets/logo_ministerio.png";
import logoPndp from "../assets/logo_pndp.png";
import "../styles/mici-ui.css";

const Header = () => {
  return (
    <div className="px-strip">
      <img
        src={logoMinisterio}
        alt="Ministerio de la Producción"
        className="px-strip-logo px-strip-logo--produce"
      />
      <span className="px-strip-tag">
        Plataforma oficial del Programa Nacional de Diversificación Productiva
      </span>
      <img
        src={logoPndp}
        alt="PNDP"
        className="px-strip-logo px-strip-logo--pndp"
      />
    </div>
  );
};

export default Header;
